// 3rd parties
import { ReactNode, MouseEvent, useRef } from "react";
import { CloseButton } from "react-bootstrap";
import styled from "styled-components";

import LoaderSpinner from "@/components/ReactBootstrap/LoaderSpinner/LoaderSpinner";
import { useOutside } from "@/hooks/useOutside";

const StyledCloseButton = styled(CloseButton)`
  width: 16px;
  height: 16px;
  padding: 0;
  background-size: 16px;
  opacity: 0.5;

  &:hover {
    opacity: 1;
  }
`;

interface RightSideBarProps {
  onClose: (value?: boolean) => void;
  loading?: boolean;
  title?: string;
  children?: ReactNode;
}

const RightSideBar = ({
  onClose,
  loading,
  title,
  children,
}: RightSideBarProps) => {
  const sideBarRef = useRef<HTMLDivElement>(null);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  useOutside(sideBarRef as any, () => {
    onClose(false);
  });

  const onCloseClick = (e: MouseEvent) => {
    e.preventDefault();
    onClose();
  };

  return (
    <div ref={sideBarRef}>
      <div className="right-sidebar side-info-panel sidebar-fixed mw-100 slideInRight animated snt-right-sidebar">
        <div className="d-flex justify-content-between align-items-start mb-3">
          <h4 style={{ fontWeight: "normal", margin: 0 }}>{title || ""}</h4>
          <StyledCloseButton onClick={onCloseClick} />
        </div>
        <div className="sidebar-inner sidebar-scrollbar pr10">
          <LoaderSpinner loading={loading} />
          {children}
        </div>
      </div>
    </div>
  );
};

export default RightSideBar;
